import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { genPageName, PageTypes } from "../../utils/PageTypes";
import { RequestState } from "../../utils/RequestState";
import FormInput from "../forms/FormInput";
import LoadingSpinner from "../LoadingSpinner";
import styles from "./ContentReport.module.scss";

type Props = {
  pageType: PageTypes;
  contentName?: string;
  requestState: RequestState;
  submitHandler: (contentReport: string) => void;
  closeHandler: () => void;
};
const ContentReportModal: React.FC<Props> = ({
  pageType,
  contentName,
  requestState,
  submitHandler,
  closeHandler,
}) => {
  const [contentReport, setContentReport] = useState<string>("");

  return (
    <div className={styles["c-report-modal-wrapper"]}>
      <div className={styles["c-report-modal"]}>
        {requestState === RequestState.Doing ? (
          <LoadingSpinner space={1} />
        ) : requestState === RequestState.Waiting ? (
          <>
            <div
              className={`${styles["c-report-modal__header"]} ${styles["modal-padding"]}`}
            >
              <FontAwesomeIcon icon={["fas", "megaphone"]} />
              <span>{`${genPageName(pageType)}を報告`}</span>
              <button
                type="button"
                onClick={closeHandler}
                className={styles["c-report-modal__header__close-btn"]}
              >
                <FontAwesomeIcon icon={["fas", "times"]} />
              </button>
            </div>

            <div className={styles["modal-padding"]}>
              <div className={styles["c-report-modal__small-text"]}>
                {`${genPageName(pageType)}名`}
              </div>
              <div>{contentName}</div>
            </div>

            <div
              className={`${styles["c-report-modal__input-field"]} ${styles["modal-padding"]}`}
            >
              <FormInput
                type="textarea"
                label="報告内容"
                label_class={styles["c-report-modal__small-text"]}
                id=""
                name="sonic_message"
                rows={8}
                handler={(value: File | string | undefined) => {
                  if (typeof value === "string") setContentReport(value);
                }}
              />
            </div>

            <div
              className={`${styles["c-report-modal__small-text"]} ${styles["modal-padding"]} ${styles["dividing-line"]}`}
            >
              報告されたコンテンツは違反しているかどうかSELeCT運営が確認いたします。
            </div>
          </>
        ) : requestState === RequestState.Failed ? (
          <>
            <div
              className={`${styles["modal-padding"]} ${styles["sent-message"]}`}
            >
              {`送信に失敗しました。\nお手数ですが、再度お試しください。`}
            </div>
          </>
        ) : (
          <>
            <div
              className={`${styles["modal-padding"]} ${styles["sent-message"]}`}
            >
              {`ご報告ありがとうございます。\nSELeCT運営にて確認いたします。\nSELeCTがより良いサービスとなるよう今後ともよろしくお願いいたします`}
            </div>
          </>
        )}

        {requestState !== RequestState.Doing ? (
          <div className={styles["modal-padding"]}>
            {requestState === RequestState.Waiting ? (
              <button
                type="button"
                onClick={() => submitHandler(contentReport)}
                className={styles["c-report-modal__action-btn"]}
              >
                送信
              </button>
            ) : (
              <button
                type="button"
                onClick={closeHandler}
                className={styles["c-report-modal__action-btn"]}
              >
                閉じる
              </button>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ContentReportModal;
